import '../loader/index.js';

import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';

export const COMPONENT_TAG = 'fly-stat-card';

/**
 * StatCard -- Description here
 */
@customElement(COMPONENT_TAG)
export default class FlyStatCard extends FlywheelComponent {
  @property({type: Number})
  value: number = Number.NaN;

  @property()
  label = '';

  @property({type: Boolean, reflect: true})
  loading = false;

  static get styles() {
    return [styles];
  }

  get computedValue(): string {
    if (typeof this.value === 'number' && !Number.isNaN(this.value)) {
      return this.value.toLocaleString();
    }

    return '-';
  }

  render() {
    return html`
      <div class="stat-card">
        <div class="stat-card__value">
          <fly-loader ?loading=${this.loading}>
            ${this.computedValue}
          </fly-loader>
        </div>
        <div class="stat-card__label">${this.label}</div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [COMPONENT_TAG]: FlyStatCard;
  }
}
